<template>
  <div id="surveys">
    <Nodata
      :title="$t('nodatakeys.surveys.nodatatitle')"
      :description="$t('nodatakeys.surveys.nodatadesc')"
      anim="holacon-surveys-lottie"
      :loading="loading"
      v-if="surveys.length == 0"
      :button="$t('nodatakeys.surveys.nodatabutton')"
      @btnClick="getdata"
    />

    <div
      v-if="survey != null"
      style="display: flex; flex-direction: row; align-items: center;"
      @click="survey = null"
    >
      <md-button class="md-icon-button">
        <md-icon>arrow_back</md-icon>
      </md-button>
      <span>{{$t('back_surveys')}}</span>
    </div>

    <div class="surveys" v-if="survey == null && ids == null">
      <div class="survey" v-for="survey in surveys" :key="survey.survey.id" @click="doSurvey(survey)">
        <div class="survey-title">
          <span>{{ survey.survey.title }} {{ ids }}</span>
          <span class="survey-cat" v-if="survey.isCompleted">{{ $t("event.survey.completed") }}</span>
        </div>
        <div>
          <i :class="survey.isCompleted ? 'fa fa-check' : 'fa fa-chevron-right'"></i>
        </div>
      </div>
    </div>

    <div class="surveys" v-if="survey == null && ids != null">
      <div class="survey" v-for="survey in ids" :key="survey.survey.id" @click="doSurvey(survey)">
        <div class="survey-title">
          <span>{{ survey.survey.title }}</span>
          <span class="survey-cat" v-if="survey.isCompleted">{{ $t("event.survey.completed") }}</span>
        </div>
        <div>
          <i :class="survey.isCompleted ? 'fa fa-check' : 'fa fa-chevron-right'"></i>
        </div>
      </div>
    </div>

    <div id="survey" v-if="survey != null">
      <div id="survey_detail" v-if="index != null">
        <div class="questions">
          <transition name="fade" mode="out-in">
            <div class="question" :key="index">
              <h4>{{ survey.survey.questions[index].title }}</h4>
              <div class="answers">
                <div
                  class="answer"
                  v-for="(answer, answerIndex) in survey.survey.questions[index]
                    .answers"
                  :key="answerIndex"
                >
                  <div v-if="survey.survey.questions[index].type == 3">
                    <label style="padding: 10px 15px; cursor: pointer;">
                      <input
                        type="checkbox"
                        v-model="answerForm.surveyAnswers[index].answer"
                        :value="answer"
                      />
                      {{ answer }}
                    </label>
                  </div>

                  <div v-if="survey.survey.questions[index].type == 2">
                    <label style="padding: 10px 15px; cursor: pointer;">
                      <input
                        type="radio"
                        v-model="answerForm.surveyAnswers[index].answer"
                        :value="answer"
                      />
                      {{ answer }}
                    </label>
                  </div>
                </div>
                <div
                  class="answers"
                  v-if="survey.survey.questions[index].type == 1"
                  style="width: 100%;"
                >
                  <textarea
                    name
                    v-model="answerForm.surveyAnswers[index].answer"
                    :placeholder="$t('event.survey.answer')"
                    id
                    rows="5"
                  ></textarea>
                </div>
              </div>
            </div>
          </transition>
          <div style="display: flex; align-items: center; justify-content: space-between">
            <div style="font-weight:600; font-size: 16px;">{{ survey.survey.questions.length }}/{{ index + 1 }}</div>

            <button :style="'background-color:' + $store.state.event.event.color" @click="next">
              {{ survey.survey.questions.length == index + 1 ? $t('complete_survey') : $t("next") }}
            </button>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Swal from "sweetalert2";
export default {
  name: "SurveyList",  
  props: {
    ids: {type : Array, default : null},
  },

  mounted() {},
  data() {
    return {
      surveys: [],      
      loading: true,
      survey: null,
      index: null,
      answerForm: {
        surveyID: null,
        surveyAnswers: [],
      },
      validationErrors: [],
      isError: false,
    };
  },
  async created() {
    this.getdata();
  },
  async beforeMount() {
    this.getdata();
  },
  methods: {
    next() {
      var answer = this.answerForm.surveyAnswers[this.index].answer;

      if (
        (typeof answer == "object" && answer.length == 0) ||
        answer == "" ||
        answer == null
      ) {
        Swal.fire(this.$i18n.t('swallFireNotify.warning'), this.$i18n.t('swallFireNotify.content'), "warning");
        return;
      }

      if (this.index + 1 == this.survey.survey.questions.length) {
        this.finish();
        return;
      }

      this.index += 1;
    },
    finish() {
      var data = JSON.parse(JSON.stringify(this.answerForm));
      data.surveyID = this.survey.survey.id;
      data.surveyAnswers.map((item, index) => {
        if (this.survey.survey.questions[index].type == 3) {
          data.surveyAnswers[index].answer = data.surveyAnswers[
            index
          ].answer.join(",");
        }
      });
      data.surveyID = this.survey.survey.id;
      axios
        .post("participant/dosurvey", {
          ...data,
          ...{
            firstName: null,
            lastName: null,
            email: null,
            phoneNumber: null,
          },
        })
        .then((res) => {
          Swal.fire("Anket Tamamlandı", res.data.message, "success");
          this.survey.isCompleted = true;
          this.survey = null;
          this.getdata();
        });
    },
    async getdata() {
      this.loading = true;
      var response = await axios.post("participant/getsurveys");
      this.surveys = response.data.data.items;
      this.loading = false;
    },
    doSurvey(s) {
      if (s.isCompleted) {
        return;
      }
      s.survey.questions.map((item) => {
        this.answerForm.surveyAnswers.push({
          questionID: item.id,
          answer: item.type == 1 ? "" : item.type == 2 ? "" : [],
        });
      });
      this.survey = s;
      this.index = 0;      
    },
  },
  watch: {
    survey: function () {
      if (this.survey == null) {
        this.answerForm = {
          surveyID: null,
          surveyAnswers: [],
        };
      }
    },
  },
};
</script>

<style lang="less" scoped>
#surveys {

  #survey {
    color: #2c3e50;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;

    #survey_detail {
      width: 100%;
    }

    h3,
    h4 {
      text-align: center;
      width: 100%;
      display: block;
      margin: 0px;
      margin: 15px 0px;
      font-size: 16px;
      font-weight: 500;
    }

    .form {
      padding: 10px 15px;
      width: 100%;
      box-sizing: border-box;
    }

    .form-row {
      width: 100%;
      margin: 0px;
      margin-top: 10px;
    }

    input {
      outline: none;
    }

    input[type="text"],
    input[type="email"],
    textarea {
      padding: 5px 10px;
      width: 100%;
    }

    button {
      outline: none;
      border: none;
      padding: 10px 15px;
      background-color: #333;
      color: white;
      font-weight: 600;
      font-size: 16px;
      cursor: pointer;          
      border-radius: 8px;
    }

    .answer label {
      display: block;
      width: 100%;
    }

    .error {
      color: red;
      font-size: 14px;
    }
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }

    .answers {
      padding: 8px 8px 8px 8px;
      margin-bottom: 15px;
      border-radius: 8px;
      border: 0.5px solid #D6D9D9;
      background: #fbfbfb;

    }
  }

  .surveys {
    width: 100%;

    .survey {
      
      display: flex;
      border: 0.5px solid #D6D9D9;
      width: 100%;
      padding: 6px 16px;
      min-height: 60px;
      font-weight: 600;
      font-size: 16px;
      border-radius: 8px;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      transition: 1s;
      margin-bottom: 10px;

      .survey-title {

        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;

        span {
          font-weight: 600;
          font-size: 16px;
        }

        .survey-cat {
          font-weight: 400;
          font-size: 14px;
          background: #73cccc;
          padding: 6px 10px;
          border-radius: 8px;
          color: white;
        }
      }

      i {
        font-size: 18px;
        font-weight: 400;
        margin-left: 10px;
        margin-top: 2px;
      }
    }
  }   
  
}
</style>



// WEBPACK FOOTER //
// src/components/event/SurveyList.vue